<template>
  <div class="layoga-coupon">
    <div class="container">
      <div class="content">
        <h1>{{ t('Layoga Coupon') }}</h1>
        <p v-if="loading">{{ t('Loading...') }}</p>
        <p v-else-if="error">{{ t(error) }}</p>
        <p v-else-if="showMobileOnly">{{ t('This coupon is only available on mobile.') }}</p>
        <div v-if="!loading && coupon">
          <p>{{ t('Use this coupon to get a discount on your next purchase at Layoga.') }}</p>
          <div class="flexy padded">
          <p>{{ t('Coupon code') }}: <strong>{{ coupon }}</strong></p>
          </div>
          <p>{{ t('Please note that this coupon is only valid for one use.') }}</p>
          <p>{{ t('To use this coupon, download the Layoga app and enter the coupon code at checkout.') }}</p>

          <button class="btn" @click="gotoAppStore">
            {{ t('Download the Layoga app') }}
          </button>

          <h4>{{t("How to apply your coupon")}}</h4>
          <div v-if="platform==='ios'">{{t("ios-layoga-instructions")}}</div>
          <div v-if="platform==='android'">{{t("android-layoga-instructions")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import t from "@/lib/Locale";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import Fito from "@/lib/fito";

const iosLink = "https://apps.apple.com/app/layoga-%D7%9C%D7%99%D7%95%D7%92%D7%94/id6502337648";
const androidLink = "https://play.google.com/store/apps/details?id=com.fito.layoga&pli=1";

export default {
  name: "LayogaCoupon",
  components: {},

  data() {
    return {
      iosLink, androidLink,
      ArrowRightIcon,
      accountNotEligible: false,
      loading: false,
      coupon: null,
      error: null,
      showMobileOnly: false,
      platform: null,
    }
  },

  mounted() {
    this.init();
  },

  computed : {
  },

  methods : {
    t,
    gotoAppStore() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {
        window.open(iosLink, '_blank');
      } else if (navigator.userAgent.match(/Android/)) {
        window.open(androidLink, '_blank');
      }
    },
    async init() {
      const check = await Fito().Login.safeCheckLogin();
      if (!check) return this.$router.push('/plan/login?redirect=/plan/bonus/layoga-coupon');

      this.loading = true;
      try {
        const couponType = "layoga"
        let platform = "web"
        // set to either iphone or android if on mobile
        if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {
          platform = "ios"
        } else if (navigator.userAgent.match(/Android/)) {
          platform = "android"
        }

        if (platform === "web") {
          this.showMobileOnly = true;
          return;
        }

        this.platform = platform;

        const result = await Fito().Plan.getMobileAppCoupon(couponType, platform);
        this.coupon = result['coupon_code']
      }
      catch (e) {
        this.error = e;
      }
      finally {
        this.loading = false;
      }
    },
  }
}
</script>